<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="tempeoraryManName" :placeholder="$t('message.tempeoraryNameTitle')"></el-input>
        </div>
        <div class="search_item">
          <el-date-picker
            v-model="attendanceTime"
            type="datetimerange"
            range-separator=" - "
            :start-placeholder="$t('message.attendanceTimeTitle') + $t('message.orderTimeStartHolder')"
            :end-placeholder="$t('message.attendanceTimeTitle') + $t('message.orderTimeEndHolder')"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="center"
          ></el-date-picker>
        </div>
        <div class="search_btn" @click="searchTempeoraryName">{{$t('message.searchBtnText')}}</div>
        <div style="margin-left: 20px;">
          <span>{{$t('message.todayClockNum')}}: {{todayTemporary}}</span>
        </div>
      </div>
      <div class="search_box">
        <div class="add_btn" @click="addNewTempeorary">
          <img class="add_icon" src="@/assets/addIcon.svg" />
          {{$t('message.addTempeoraryManTitle')}}
        </div>
        <div
          class="add_btn"
          style="margin-left: 10px;"
          @click="exportMoreTempeorary"
        >{{$t('message.exportText')}}</div>
      </div>
    </div>
    <!-- 搜索栏 -->
    <div class="content">
      <div class="tableBox">
        <el-table
          id="tempeoraryMenList"
          :data="tempeoraryMenList"
          style="width: 100%"
          stripe
          size="small"
          header-cell-class-name="tableHeader"
          cell-class-name="tableBodyer"
          height="100%"
          v-loading="loading"
        >
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
          <el-table-column
            :label="$t('message.tempeoraryNameTitle')"
            prop="USHOWNAME"
            min-width="100"
          ></el-table-column>
          <el-table-column
            :label="$t('message.tempeoraryPhoneTitle')"
            prop="TELPHONE"
            min-width="120"
          ></el-table-column>
          <el-table-column :label="$t('message.tempeoraryEmailTitle')" prop="EMAIL" min-width="150"></el-table-column>
          <el-table-column
            :label="$t('message.tempeoraryAccountTitle')"
            prop="UINPUTNAME"
            min-width="120"
          ></el-table-column>
          <!-- <el-table-column :label="$t('message.tempeoraryPasswordTitle')" prop="password"></el-table-column> -->
          <el-table-column :label="$t('message.airportWageTitle')" prop="GD1" width="120"></el-table-column>
          <el-table-column :label="$t('message.warehouseWageTitle')" prop="GD2" width="120"></el-table-column>
          <el-table-column :label="$t('message.dailyWageTitle')" prop="GD3" width="140"></el-table-column>
          <el-table-column :label="$t('message.hourlyWageTitle')" prop="SHIXIN" width="120"></el-table-column>
          <el-table-column :label="$t('message.monthlyPassTitle')" prop="YUEPIAO" width="120"></el-table-column>
          <el-table-column :label="$t('message.attendanceNumTitle')" prop="GD4" width="120"></el-table-column>
          <el-table-column :label="$t('message.attendanceHoursTitle')" prop="GD5" width="120"></el-table-column>
          <el-table-column :label="$t('message.clockInDetailTitle')" min-width="100" fixed="right">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button
                  class="operation_btn"
                  type="text"
                  @click.native.prevent="checkDetail(scope.row)"
                >{{$t('message.customTableContent')}}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="130" fixed="right">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button
                  class="operation_btn updateBtn"
                  type="text"
                  size="small"
                  @click.native.prevent="updateTempeorary(scope.row)"
                ></el-button>
                <el-button
                  class="operation_btn delBtn"
                  type="text"
                  size="small"
                  @click.native.prevent="delTempeorary(scope.row.ID)"
                ></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage"
      ></el-pagination>
    </div>
    <!-- 添加修改临时员工 -->
    <el-dialog
      :title="maskBoxTitle"
      :visible.sync="showMaskBox"
      width="50%"
      :close-on-click-modal="false"
      center
    >
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryNameTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.USHOWNAME"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryPhoneTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.TELPHONE"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryEmailTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.EMAIL"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryAccountTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.UINPUTNAME"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryPasswordTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.PASSWORD"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.airportWageTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.GD1"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.warehouseWageTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.GD2"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.dailyWageTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.GD3"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.hourlyWageTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.SHIXIN"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.monthlyPassTitle')}}</span>
            <el-input
              v-model="tempeoraryInfo.YUEPIAO"
              :placeholder="$t('message.placeholder')"
              class="dialog_item_input"
            ></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showMaskBox = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="addNewTempeoraryMan">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTempeoraryList,
  setTempeoraryMan,
  delTempeoraryMan,
  getTodayTemporary,
  HTTPS,
  exportMoreTempeorary,
} from '@/api/getData.js'
export default {
  name: 'tempeoraryManage',
  data() {
    return {
      tempeoraryManName: '',
      attendanceTime: null,
      todayTemporary: 0,
      loading: false,
      tempeoraryMenList: [],
      page_no: 1,
      page_size: 10,
      pageSizes: [10, 20, 30, 50, 100],
      totalSize: 0,
      showMaskBox: false,
      maskBoxTitle: '',
      tempeoraryInfo: {
        ID: 0,
        UINPUTNAME: '',
        USHOWNAME: '',
        PASSWORD: '',
        TELPHONE: '',
        EMAIL: '',
        GD1: '',
        GD2: '',
        GD3: '',
        SHIXIN: '',
        YUEPIAO: '',
      },
    }
  },
  created() {
    let param = this.$store.state.JHSS_tempeoraryManage_param
    if (param.PAGE) this.page_no = param.PAGE
    if (param.TYPE) this.page_size = param.TYPE
    if (param.USHOWNAME) this.tempeoraryManName = param.USHOWNAME
    if (param.UADDTIME && param.DADDTIME)
      this.attendanceTime = [param.UADDTIME, param.DADDTIME]
    this.getTempeoraryList(param)
  },
  methods: {
    // 查询临时员工列表
    async getTempeoraryList(param) {
      this.loading = true
      param = param || {}
      param.PAGE = this.page_no
      param.TYPE = this.page_size
      let res = await getTempeoraryList(param)
      this.loading = false
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else {
        this.totalSize = res.data.num
        let _this = this
        let index = (this.page_no - 1) * this.page_size
        this.tempeoraryMenList = res.data.dt.map((item) => {
          item.index = ++index
          item.password = '******'
          return item
        })
        this.$store.commit('setTempeoraryManageParam', param)
        this.getTodayTemporary()
      }
    },
    async getTodayTemporary() {
      let res = await getTodayTemporary({})
      this.todayTemporary = res.data.result
    },
    // 搜索临时员工姓名
    searchTempeoraryName() {
      this.searchFun()
    },
    // 申请条数
    sizeChange(val) {
      this.page_size = val
      this.searchFun()
    },
    // 当前页
    currentChange(val) {
      this.searchFun(val)
    },
    searchFun(val) {
      this.page_no = val || 1
      let param = {}
      if (this.tempeoraryManName) param.USHOWNAME = this.tempeoraryManName
      if (this.attendanceTime) {
        param.UADDTIME = this.attendanceTime[0]
        param.DADDTIME = this.attendanceTime[1]
      }
      this.getTempeoraryList(param)
    },
    // 添加新的临时员工
    addNewTempeorary() {
      this.tempeoraryInfo = this.$options.data().tempeoraryInfo
      this.maskBoxTitle = this.$t('message.addTempeoraryManTitle')
      this.showMaskBox = true
    },
    // 更新临时员工
    updateTempeorary(obj) {
      for (var key in this.tempeoraryInfo) {
        this.tempeoraryInfo[key] = obj[key]
      }
      this.maskBoxTitle = this.$t('message.updateTempeoraryManTitle')
      this.showMaskBox = true
    },
    async addNewTempeoraryMan() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let param = {
        ...this.tempeoraryInfo,
      }
      let res = await setTempeoraryMan(param)
      loading.close()
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else if (res.data.result !== '1') {
        this.$message.error(res.data.message)
      } else {
        this.showMaskBox = false
        this.getTempeoraryList()
      }
    },
    // 删除临时员工
    delTempeorary(id) {
      this.$confirm(
        this.$t('message.delTempeoraryPeompt'),
        this.$t('message.promptTitle'),
        {
          closeOnClickModal: false,
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText'),
        }
      )
        .then(() => {
          this.del(id)
        })
        .catch(() => {
          this.$message(this.$t('message.canclePrompt'))
        })
    },
    async del(id) {
      let param = { ID: id }
      let res = await delTempeoraryMan(param)
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
        return
      }
      if (res.data.result !== '1') {
        this.$message.error(res.data.message)
      } else {
        this.searchTempeoraryName()
      }
    },
    // 查看打卡明细
    checkDetail(obj) {
      this.$router.push({
        path: '/clockStatistics',
        query: {
          tempeoraryInfo: JSON.stringify(obj),
          attendanceTime: JSON.stringify(this.attendanceTime),
        },
      })
    },
    // 导出多个临时员工工资表
    async exportMoreTempeorary() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let param = this.$store.state.JHSS_tempeoraryManage_param
      let res = await exportMoreTempeorary(param)
      loading.close()
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else {
        // console.log(res.data)
        let str = HTTPS + '/xlsx/' + res.data
        window.open(str)
      }
    },
  },
}
</script>

<style scoped>
</style>
